import {
    useContext, useEffect, useMemo,
} from 'react';
import { useQuery } from '@tanstack/react-query';
import { httpClient } from '@s20/services/httpClient';
import { ApiRoutes } from '../../Common';
import ValidatedSelect from '../../common/forms/ValidatedSelect';
import { FormContext } from '../../common/forms/FormElements';

export const useDispatchPorts = (dispatchOfficeId) => {
    const { data: ports, isLoading: portsIsLoading } = useQuery({
        queryKey: ['dispatchPorts', dispatchOfficeId],
        queryFn: () => httpClient.js(ApiRoutes.typeAheads.dispatchPorts(dispatchOfficeId)),
        enabled: !!dispatchOfficeId,
    });

    const defaultPortId = ports?.find((x) => x.isDefault)?.value ?? null;
    const options = useMemo(() => {
        if (!ports?.length) return [];
        return ports;
    }, [ports]);

    return {
        options,
        defaultPortId,
        isLoading: portsIsLoading,
    };
};

export const DispatchPort = ({ dispatchOfficeId, name = 'dispatchPortId' }) => {
    const context = useContext(FormContext);
    const { options, defaultPortId, isLoading } = useDispatchPorts(dispatchOfficeId);

    useEffect(() => {
        if (!options.length || !defaultPortId || !context) return;
        const currentValue = context.values?.[name];
        if (currentValue === '' || currentValue === undefined) {
            context.setFieldValue(name, defaultPortId);
        }
    }, [context, name, options, defaultPortId]);

    if (!dispatchOfficeId || !options.length) {
        return null;
    }

    return (
        <ValidatedSelect
            id="dispatchPortId"
            name={name}
            options={options}
            label="Dispatch Port"
            placeholder="Use office location"
            isLoading={isLoading}
        />
    );
};
